import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'controlError'
})
export class ControlFeildErrorPipe implements PipeTransform {
    transform(error: any, label: any): any {
        if (error) {
            if (!label) {
                label = 'field';
            }
            if (error.required) {
                return `${label} is required`;
            } else if (error.pattern) {
                return error.message || `Invalid value.`;
            } else if (error.email || error.matDatepickerMin || error.matDatepickerMax || error.matDatepickerParse) {
                return `Please enter valid ${label}`;
            } else if (error.minValue) {
                return error.message || `${label} should be greater than ${error.value}`;
            } else if (error.minLength) {
                return error.message || `${label} should have minimum ${error.value} characters`;
            } else if (error.maxValue) {
                return error.message || `${label} should be less than ${error.value}`;
            } else if (error.maxLength) {
                return error.message || `${label} should have maximum ${error.value} characters`;
            } else if (error.passwordMissmatch) {
                return error.message || `Password and Confirm password should be same`;
            }
            return `invalid field`;
        }
        return '';
    }
}
